export class HrPerCriteriaCatalogDefinitionKey {
    private static readonly keyPrefix = 'hrPerCriteriaCatalogDef';
    public static title = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.pageHeader`;
    public static criteria = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.criteria`;
    public static criteriaName = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.criteriaName`;
    public static objectNumber = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.objectNumber`;
    public static perCriteriaType = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.perCriteriaType`;
    public static shortText = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.shortText`;
    public static longText = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.longText`;
    public static perEvaluationType = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.perEvaluationType`;
    public static perEvaluationUnit = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.perEvaluationUnit`;
    public static perCalculationDirection = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.perCalculationDirection`;
    public static goalValue = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.goalValue`;
    public static minValue = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.minValue`;
    public static maxValue = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.maxValue`;
    public static maxScore = `${HrPerCriteriaCatalogDefinitionKey.keyPrefix}.maxScore`;
}
